import { useParams } from 'react-router-dom';

const PLAY_STORE = 'https://play.google.com/store/apps/details?id=com.pottypal.app';

export default function InvitePage() {
  const { id } = useParams();

  const handleOpenApp = () => {
    const isAndroid = /android/i.test(navigator.userAgent);

    if (isAndroid && id) {
      const appUrl = `pottypal://invite/${id}`;
      const timer = setTimeout(() => {
        window.location.href = PLAY_STORE;
      }, 2000);

      window.location.href = appUrl;
      window.addEventListener('blur', () => clearTimeout(timer), { once: true });
    } else {
      window.location.href = PLAY_STORE;
    }
  };

  return (
    <div
      style={{
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        background: 'linear-gradient(135deg, #5B3FA6 0%, #7C5CBF 100%)',
        fontFamily: 'Nunito, sans-serif',
        padding: '24px',
        textAlign: 'center',
      }}
    >
      <div style={{ fontSize: 80 }}>👶</div>

      <h1
        style={{
          color: '#fff',
          fontSize: 26,
          fontWeight: 800,
          margin: '16px 0 8px',
          lineHeight: 1.3,
        }}
      >
        You&apos;ve been invited to PottyPal!
      </h1>

      <p
        style={{
          color: 'rgba(255,255,255,0.85)',
          fontSize: 16,
          marginBottom: 36,
          maxWidth: 320,
          lineHeight: 1.6,
        }}
      >
        Tap below to open the app and accept your invitation. If you don&apos;t have the app yet,
        you&apos;ll be taken to the Play Store.
      </p>

      <button
        type="button"
        onClick={handleOpenApp}
        style={{
          background: '#FF8C69',
          color: '#fff',
          padding: '16px 40px',
          borderRadius: 50,
          fontWeight: 800,
          fontSize: 17,
          border: 'none',
          cursor: 'pointer',
          width: '100%',
          maxWidth: 320,
          boxShadow: '0 4px 20px rgba(255,140,105,0.4)',
          marginBottom: 16,
        }}
      >
        Open PottyPal App
      </button>

      <a
        href={PLAY_STORE}
        style={{
          color: 'rgba(255,255,255,0.7)',
          fontSize: 14,
          textDecoration: 'underline',
        }}
      >
        Download from Play Store instead
      </a>

      <p
        style={{
          color: 'rgba(255,255,255,0.5)',
          fontSize: 12,
          marginTop: 32,
          maxWidth: 280,
        }}
      >
        This invite link was sent via PottyPal — the AI potty training app.
      </p>
    </div>
  );
}
